import {
  //
  ADD_FAQS,
  ADD_FAQS_FAILURE,
  ADD_FAQS_SUCCESS,
  //
  DELETE_FAQS,
  DELETE_FAQS_FAILURE,
  DELETE_FAQS_SUCCESS,
  //
  EDIT_FAQS,
  EDIT_FAQS_FAILURE,
  EDIT_FAQS_SUCCESS,
  //
  FETCH_FAQS,
  FETCH_FAQS_FAILURE,
  FETCH_FAQS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchFaqs = (payload) => ({
  type: FETCH_FAQS,
  payload,
});
export const fetchFaqsSuccess = (payload) => ({
  type: FETCH_FAQS_SUCCESS,
  payload,
});
export const fetchFaqsFailure = (payload) => ({
  type: FETCH_FAQS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addFaqs = (payload) => ({
  type: ADD_FAQS,
  payload,
});
export const addFaqsSuccess = (payload) => ({
  type: ADD_FAQS_SUCCESS,
  payload,
});
export const addFaqsFailure = (payload) => ({
  type: ADD_FAQS_FAILURE,
  payload,
});
// EDIT
export const editFaqs = (payload) => ({
  type: EDIT_FAQS,
  payload,
});
export const editFaqsSuccess = (payload) => ({
  type: EDIT_FAQS_SUCCESS,
  payload,
});
export const editFaqsFailure = (payload) => ({
  type: EDIT_FAQS_FAILURE,
  payload,
});
// DELETE
export const deleteFaqs = (payload) => ({
  type: DELETE_FAQS,
  payload,
});
export const deleteFaqsSuccess = (payload) => ({
  type: DELETE_FAQS_SUCCESS,
  payload,
});
export const deleteFaqsFailure = (payload) => ({
  type: DELETE_FAQS_FAILURE,
  payload,
});
